import * as go from 'gojs';

export class ParallelRouteLink extends go.Link {
  constructor() {
    super();
  }
  computePoints() {
    const result = super.computePoints();
    if (
      !this.isOrthogonal &&
    this.curve !== go.Link.Bezier &&
    this.hasCurviness()
    ) {
      const curv = this.computeCurviness();
      if (curv !== 0) {
        const num = this.pointsCount;
        let pidx = 0;
        let qidx = num - 1;
        if (num >= 4) {
          pidx++;
          qidx--;
        }

        const fromPoint = this.getPoint(pidx);
        const toPoint = this.getPoint(qidx);

        const dx = toPoint.x - fromPoint.x;
        const dy = toPoint.y - fromPoint.y;

        let mx = fromPoint.x + (dx * 1) / 8;
        let my = fromPoint.y + (dy * 1) / 8;

        let px = mx;
        let py = my;

        if (-0.01 < dy && dy < 0.01) {
          if (dx > 0) py -= curv;
          else py += curv;
        } else {
          const slope = -dx / dy;
          let e = Math.sqrt((curv ** 2) / (slope ** 2 + 1));
          if (curv < 0) e = -e;
          px = (dy < 0 ? -1 : 1) * e + px;
          py = slope * (px - mx) + my;
        }

        mx = fromPoint.x + (dx * 7) / 8;
        my = fromPoint.y + (dy * 7) / 8;
        let qx = mx;
        let qy = my;
        if (-0.01 < dy && dy < 0.01) {
          if (dx > 0) qy -= curv;
          else qy += curv;
        } else {
          const slope = -dx / dy;
          let e = Math.sqrt((curv ** 2) / (slope ** 2 + 1));
          if (curv < 0) e = -e;
          qx = (dy < 0 ? -1 : 1) * e + mx;
          qy = slope * (qx - mx) + my;
        }

        this.insertPointAt(pidx + 1, px, py);
        this.insertPointAt(qidx + 1, qx, qy);
      }
    }
    return result;
  }
}
